module.exports = __webpack_public_path__ + "images/help/icon-twr38-3a35b92f138f55317723bca90f607c82.png";